import React from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import PNGColorIcon from '../svg/PNGColorIcon';
import PDFColorIcon from '../svg/PDFColorIcon';
import DownloadIcon from '../svg/DownloadIcon';
import JPGColorIcon from '../svg/JPGColorIcon';
import CloseIcon from '../svg/CloseIcon';

const useStyles = makeStyles({
  container: {
    marginTop: 10,
    display: 'flex',
    padding: 10,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    backgroundColor: 'white',
    borderRadius: 8,
    alignItems: 'center',
    cursor: 'pointer',
    flexWrap: 'wrap'
  },
  titleStyle: {
    color: 'black',
    fontSize: 16,
    marginLeft: 5,
    marginRight: 10,
    maxWidth: '80%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1
  },
  rightIcon: {
    marginLeft: 'auto',
    marginRight: 10,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center'
  }
});

export default function DownloadFileContainer({
  title,
  fileLink,
  isDownload,
  onCancelClick,
  size = { width: 48, height: 48 }
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const downloadFile = () => {
    fetch(fileLink)
      .then((r) => r.blob())
      .then((blob) => {
        const element = document.createElement('a');
        document.body.appendChild(element);
        element.setAttribute('href', window.URL.createObjectURL(blob));
        element.setAttribute('download', title);
        element.style.display = '';

        element.click();

        document.body.removeChild(element);
      })
      .catch(() =>
        enqueueSnackbar('There is something wrong while downloading', {
          variant: 'error'
        })
      );
  };

  return (
    <div className={classes.container}>
      {title.includes('.pdf') && <PDFColorIcon height={size.height} width={size.width} />}
      {title.includes('.jpg') && <JPGColorIcon height={size.height} width={size.width} />}
      {title.includes('.jpeg') && <JPGColorIcon height={size.height} width={size.width} />}
      {title.includes('.png') && <PNGColorIcon height={size.height} width={size.width} />}
      <p className={classes.titleStyle}>{title}</p>
      {isDownload && (
        <div className={classes.rightIcon} role="presentation" onClick={() => downloadFile()}>
          <DownloadIcon />
        </div>
      )}
      {onCancelClick && (
        <div className={classes.rightIcon} role="presentation" onClick={onCancelClick}>
          <CloseIcon width={15} height={15} />
        </div>
      )}
    </div>
  );
}

DownloadFileContainer.propTypes = {
  title: PropTypes.string,
  fileLink: PropTypes.string,
  isDownload: PropTypes.bool,
  onCancelClick: PropTypes.func,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  })
};
